import React from "react";

type Props = {
  onClose?: () => void;
  onSubmit?: () => void;
};

const ModalFooter: React.FC<Props> = ({ onClose, onSubmit }) => {
  return (
    <div className="res-modal__footer">
      <button
        className="btn btn-primary"
        onClick={onSubmit}
        style={{ height: "fit-content" }}
      >
        تایید
      </button>
      <button
        className="btn btn-secondary bg-white ml-2"
        onClick={onClose}
        style={{ height: "fit-content" }}
      >
        انصراف
      </button>
    </div>
  );
};

export default React.memo(ModalFooter);
